import Calculator from "./Calculator";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

const appRoot = document.getElementById("beevee-backup-price-calculator");
if (!appRoot) console.log("Cannot find #beevee-backup-price-calculator.");

ReactDOM.render(
  <React.StrictMode>
    <Calculator
      imgPath={appRoot.attributes["data-imgpath"]?.value || "/img"}
      postUrl={appRoot.attributes["data-posturl"]?.value || "/form.php"}
      postFieldName={appRoot.attributes["data-postfieldname"]?.value || "beevee_backup_calculator_msg_body"}
    />
  </React.StrictMode>,
  appRoot
);
